import { render, staticRenderFns } from "./CreateCardBtn.vue?vue&type=template&id=1c329573&scoped=true&"
import script from "./CreateCardBtn.vue?vue&type=script&lang=js&"
export * from "./CreateCardBtn.vue?vue&type=script&lang=js&"
import style0 from "./CreateCardBtn.vue?vue&type=style&index=0&id=1c329573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c329573",
  null
  
)

export default component.exports